import { createFileRoute } from '@tanstack/react-router';

import { PkPage } from '@fields/feature';

export const Route = createFileRoute('/_app/fields_/$fieldId/pk')({
  component: PkPage,
});
